export type GraphQLResponseWithData<TData> = {
  data: TData
}

export type GraphQLResponseError = {message: string}

export type GraphQLResponseWithErrors = {
  errors: GraphQLResponseError[]
}

export type GraphQLResponse<TData> = GraphQLResponseWithData<TData> | GraphQLResponseWithErrors

/**
 * Checks the response for a data property - if it exists just return the response, but cast
 * to the GraphQLResponseWithData shape.
 * If an errors property exists, throw an error, with the message of the first error from the response.
 * If neither exists, throw a generic error
 * @param response
 * @returns
 */
export function parseGraphQLResponse<TData>(response: GraphQLResponse<TData>): GraphQLResponseWithData<TData> {
  if ('data' in response) {
    return response
  } else if ('errors' in response) {
    if (Array.isArray(response.errors) && response.errors.length > 0 && response.errors[0]?.message)
      throw new Error(response.errors[0].message)
  }
  // This is unexpected, but somehow we got data without a data or errors property,
  // so just throw an error
  throw new Error('Error in request')
}
